import { Suspense, lazy } from 'react';

const TeamDetails = lazy(() => import('../components/Teams/TeamDetails'));

const TeamDetailsLazy: React.FC = () => {
    return <Suspense><TeamDetails/></Suspense>;
}

export default TeamDetailsLazy;
